import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { millTour } from '../mock/mock';

// Interactive step-by-step mill tour
const MillTour = () => {
  const [active, setActive] = useState(0);
  const current = millTour[active];

  return (
    <div id="mill-tour" className="scroll-mt-24">
      {/* Featured mill tour video */}
      <div className="mb-8 rounded-2xl overflow-hidden shadow-xl border-4 border-ktc-ivory/40 bg-ktc-greenDark">
        <video
          src="/mill-tour.mp4"
          controls
          playsInline
          preload="metadata"
          poster="/loading.jpg"
          className="w-full max-h-[520px] object-contain bg-black"
        >
          Your browser does not support the video tag.
        </video>
      </div>

      <div className="grid lg:grid-cols-5 gap-8 items-stretch">
        {/* Step list */}
        <div className="lg:col-span-2 space-y-2">
          {millTour.map((s, i) => {
            const isActive = i === active;
            return (
              <button
                key={s.step}
                onClick={() => setActive(i)}
                onMouseEnter={() => setActive(i)}
                className={`w-full text-left flex items-center gap-4 rounded-xl border p-4 transition-colors ${isActive ? 'bg-ktc-green border-ktc-green' : 'bg-ktc-ivoryLight border-ktc-cream hover:border-ktc-gold'}`}
              >
                <span className={`font-serif text-2xl font-bold ${isActive ? 'text-ktc-goldLight' : 'text-ktc-gold'}`}>{s.step}</span>
                <span className={`font-sans text-[15px] font-semibold flex-1 ${isActive ? 'text-ktc-ivory' : 'text-ktc-green'}`}>{s.title}</span>
                <ChevronRight size={18} className={isActive ? 'text-ktc-goldLight' : 'text-ktc-charcoal/30'} />
              </button>
            );
          })}
        </div>

        {/* Active step preview */}
        <div className="lg:col-span-3">
          <div className="relative rounded-2xl overflow-hidden shadow-xl h-full min-h-[360px]">
            <img key={current.image} src={current.image} alt={current.title} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ktc-greenDark/90 via-ktc-greenDark/25 to-transparent" />
            <div className="absolute bottom-0 inset-x-0 p-8">
              <span className="text-ktc-goldLight font-serif text-3xl font-bold">{current.step}</span>
              <h3 className="font-serif text-3xl font-semibold text-ktc-ivory mt-1">{current.title}</h3>
              <p className="text-ktc-ivory/85 mt-3 max-w-xl leading-relaxed">{current.text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MillTour;
